import { ListingStatusEnum } from '../../shared/constants/listing-statuses';

export enum VisualsStatusEnum {
    UNKNOWN = 'UNKNOWN',
    DRAFT = 'Draft',
    PENDING_ACTIVATION = 'PendingActivation',
    LIVE = 'Live',
}

export enum VisualsPartState {
    LOADING = 'LOADING',
    HIDDEN = 'HIDDEN',
    UNAVAILABLE = 'UNAVAILABLE',
}

export type VisualsPartStatus = Exclude<VisualsStatusEnum, VisualsStatusEnum.UNKNOWN> | VisualsPartState;

export interface ListingVisualsStatusChangedData {
    ListingId: string;
}

export interface IceVisualListingStatusApiResponse {
    status: VisualsStatusEnum;
    listingInstanceId?: number;
}

export const legacyVisualsListingStatusMap: { [key in VisualsStatusEnum]: ListingStatusEnum } = {
    [VisualsStatusEnum.UNKNOWN]: ListingStatusEnum.UNKNOWN,
    [VisualsStatusEnum.DRAFT]: ListingStatusEnum.DRAFT,
    [VisualsStatusEnum.PENDING_ACTIVATION]: ListingStatusEnum.APPROVAL,
    [VisualsStatusEnum.LIVE]: ListingStatusEnum.LIVE,
};
